export const statusList = [
  { label: '待生效', id: 0 },
  { label: '生效中', id: 1 },
  { label: '已结束', id: 2 },
];
export const couponRuleMap = [
  { label: '满减券', id: 1 },
  { label: '折扣券', id: 2 },
  { label: '立减券', id: 3 },
  { label: '运费券', id: 4 },
];

export const couponRuleEnums = ['', '满减券', '折扣券', '立减券', '运费券'];

export const activityType = [
  { label: '线下拉新', id: 0 },
  { label: '邀请带新', id: 1 },
];

export const listOperate = {
  waitAble: 0,
  able: 1,
  disable: 2,
};

export const ticketStatusList = {
  all: { text: '全部', key: 0 },
  has_received: { text: '已领取', key: 1 },
  has_checked: { text: '已核销', key: 2 },
  has_deleted: { text: '已作废', key: 3 },
};

export const typeMap = ['线下拉新', '邀请带新'];
// 是否限定企业
export const targetTypeList = [{ label: '否', id: 0 }];

export const targetTypeEnums = {
  limit: {
    name: '是',
    value: 1,
  },
  notLimit: {
    name: '否',
    value: 0,
  },
};

export const awardTypeOptions = [
  { label: '无奖励', value: 2 },
  { label: '优惠券', value: 0 },
  { label: '返利金', value: 1 },
];
export const actionType = {
  add: {
    name: '新建',
    requestUrl: '/saasmerchant/web/activityConfig/saveActivityConfig',
    code: 'add',
  },
  edit: {
    name: '修改',
    requestUrl: '/saasmerchant/web/activityConfig/updateActivityConfigByActivityId',
    code: 'edit',
  },
  copy: {
    name: '新建',
    requestUrl: '/saasmerchant/web/activityConfig/saveActivityConfig',
    code: 'copy',
  },
  look: {
    name: '查看',
    code: 'look',
  },
};
export const statusMap = ['待生效', '生效中', '已结束'];
export const statusTimeMap = ['关闭', '开启'];
